module.exports = __webpack_public_path__ + "static/gm-43-f69a98ff64f39026eb938421f0b1d632.jpg";